export class ClinicalFormTypeLookup {
    getLookup() {
        let clinicalFormTypes = [];

        clinicalFormTypes.push({ label: 'Form', value: 1 });
        clinicalFormTypes.push({ label: 'Tabular', value: 2 });

        return clinicalFormTypes;
    }
}
